import routes from './routes'
import { LobbyEntryProps, LobbyEntryTypes } from './components/LobbyEntry/LobbyEntry'

// audio
import LobbyMusic from './images/audio/lobby.mp3'

// icons & decorations
import { fixedAssets } from './containers/PreCache'

const dev = {
  // apiUrl: 'http://localhost:3000',
  apiUrl: 'https://paedsympo2023.herokuapp.com',
}

const prod = {
  apiUrl: 'https://paedsympo2023.herokuapp.com',
}

const API_KEYS = {
  amplitude: 'a33323a350e0b617fb1bf22d0a575841',
}

const VOLUME_VALUE = 0.4

// Root page will show either EntrancePage or CountdownPage
// based on the following time setting
const EVENT_START_TIME = {
  year: 2023,
  month: 3,
  day: 18,
  hour: 14,
  minute: 0,
}

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 10%;
    bottom: 20%;
    left: 17%;
    right: 18%;
  `,
}

const lobbyEntries: Array<LobbyEntryProps & { id: string }> = [
  {
    id: 'auditorium-entrance-2',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.auditorium1,
    pinImage: fixedAssets.arrowIcon,
    css: `
      top: 38%;
      left: 84.5%;
      right: 17%;
      bottom: 58%;
    `,
  },
  {
    id: 'time-tunnel',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.time,
    pinImage: fixedAssets.arrowIcon,
    css: `
      top: 27%;
      left: 51.5%;
      right: 46%;
      bottom: 73%;
    `,
  },
  {
    id: 'pledge-wall',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.pledgeGallery,
    pinImage: fixedAssets.arrowIcon,
    css: `
      top: 36%;
      left: 12%;
      right: 87%;
      bottom: 64.5%;
    `,
  },
  {
    id: 'helpdesk',
    type: LobbyEntryTypes.Helpdesk,
    pinImage: fixedAssets.infoIcon,
    css: `
      top: 65%;
      left: 5%;
      right: 90%;
      bottom: 35.5%;
    `,
  },
  {
    id: 'booth-1',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.booth1,
    pinImage: fixedAssets.arrowIcon,
    css: `
      top: 82%;
      left: 53%;
      right: 47.5%;
      bottom: 16.5%;
    `,
  },
  {
    id: 'booth-2',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.booth2,
    pinImage: fixedAssets.arrowIcon,
    css: `
      top: 72%;
      left: 25.5%;
      right: 73%;
      bottom: 28%;
    `,
  },
  {
    id: 'booth-3',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.booth3,
    pinImage: fixedAssets.arrowIcon,
    css: `
      top: 75%;
      left: 82%;
      right: 18%;
      bottom: 25%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,
  EVENT_START_TIME,

  eventName: 'Paediatric Symposium 2023',

  ...config,
}
